module.exports = __webpack_public_path__ + "img/fig7.709e6fc8.png";